import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/src/app/components/Header.tsx");
